<template>
  <div class="motor-doc-uploads">
    <p v-if="hint" class="doc-upload-hint">{{ hint }}</p>
    <upload-zone
      v-if="showLogbook"
      label="Vehicle Logbook"
      required
      :upload-obj="uploads.logbook"
      @file-selected="(f) => onSelect(f, 'logbook')"
      @remove="onRemove('logbook')"
    />
    <template v-if="requiresIdOrKra">
      <upload-zone
        v-if="requiresKra"
        label="KRA PIN Certificate"
        required
        :upload-obj="uploads.kra"
        @file-selected="(f) => onSelect(f, 'kra')"
        @remove="onRemove('kra')"
      />
      <upload-zone
        v-if="requiresId"
        label="National ID"
        required
        :upload-obj="uploads.nationalId"
        @file-selected="(f) => onSelect(f, 'nationalId')"
        @remove="onRemove('nationalId')"
      />
    </template>
  </div>
</template>

<script>
import UploadZone from '@/components/agent/UploadZone';
import { validateMotorUploadFile } from '@/utils/motorDocumentUpload';

export default {
  name: 'MotorDocumentUploadPanel',
  components: { UploadZone },
  props: {
    uploads: { type: Object, required: true },
    requiresId: { type: Boolean, default: false },
    requiresKra: { type: Boolean, default: false },
    showLogbook: { type: Boolean, default: true },
    hint: { type: String, default: '' },
  },
  computed: {
    requiresIdOrKra() {
      return this.requiresId || this.requiresKra;
    },
  },
  methods: {
    onSelect(file, key) {
      const err = validateMotorUploadFile(file);
      if (err) {
        this.$toast.error(err);
        return;
      }
      this.$emit('file-selected', { file, key });
    },
    onRemove(key) {
      this.$emit('remove', key);
    },
  },
};
</script>

<style scoped lang="scss">
.doc-upload-hint {
  font-size: 0.82rem;
  color: #64748b;
  margin: 0 0 12px;
  line-height: 1.5;
}
.motor-doc-uploads :deep(.upload-zone-wrap) { margin-bottom: 12px; }
</style>
